export default __webpack_public_path__ + "static/media/youtubeIcon.5f9317bd.svg";